"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedsPolicy = exports.ActionDetails = void 0;
const CardName_1 = require("../CardName");
const ResourceType_1 = require("../ResourceType");
const SpaceBonus_1 = require("../SpaceBonus");
const StandardProjectType_1 = require("../StandardProjectType");
const Tags_1 = require("../cards/Tags");
const TileType_1 = require("../TileType");
const constants_1 = require("../constants");
const Board_1 = require("../boards/Board");
const CardType_1 = require("../cards/CardType");
const SpaceType_1 = require("../SpaceType");
const MoonExpansion_1 = require("../moon/MoonExpansion");
const AresHandler_1 = require("../ares/AresHandler");
class ActionDetails {
    constructor(action) {
        this.isPlantsConversion = false;
        this.cost = 0;
        this.TRIncrease = 0;
        this.oxygenIncrease = 0;
        this.temperatureIncrease = 0;
        this.venusIncrease = 0;
        this.moonColonyRateIncrease = 0;
        this.moonLogisticsRateIncrease = 0;
        this.moonMiningRateIncrease = 0;
        this.oceansToPlace = 0;
        this.oceansAvailableSpaces = [];
        this.nonOceanAvailableSpaces = [];
        this.animals = 0;
        this.microbes = 0;
        this.bonusMegaCredits = 0;
        this.megaCreditsProduction = 0;
        this.reservedHeat = 0;
        Object.assign(this, action);
    }
}
exports.ActionDetails = ActionDetails;
class RedsPolicy {
    static canAffordRedsPolicy(player, game, action, canUseSteel = false, canUseTitanium = false, canUseFloaters = false, canUseMicrobes = false, canUseScience = false, canUseGraphene = false, canUseAsteroids = false, canUsePlants = false, canUseSpireScience = false) {
        var _a;
        const board = game.board;
        canUsePlants = canUseSteel && player.cardIsInEffect(CardName_1.CardName.MARTIAN_LUMBER_CORP) && player.plants > 0;
        if (game.getOxygenLevel() < 8 && game.getOxygenLevel() + action.oxygenIncrease >= 8) {
            action.temperatureIncrease++;
        }
        if (action.oceansToPlace > 0 && action.oceansAvailableSpaces.length === 0) {
            action.oceansAvailableSpaces = board.getAvailableSpacesForOcean(player);
        }
        if (game.getTemperature() < 0 && game.getTemperature() + action.temperatureIncrease * 2 >= 0) {
            if (action.oceansToPlace === 0 && action.oceansAvailableSpaces.length === 0) {
                action.oceansAvailableSpaces = board.getAvailableSpacesForOcean(player);
            }
            action.oceansToPlace++;
        }
        else if (action.oceansToPlace > 0 && action.oceansAvailableSpaces.length === 0) {
            action.oceansAvailableSpaces = board.getAvailableSpacesForOcean(player);
        }
        if (game.getVenusScaleLevel() < 16 && game.getVenusScaleLevel() + action.venusIncrease * 2 >= 16) {
            action.TRIncrease++;
        }
        action.oxygenIncrease = Math.min(action.oxygenIncrease, constants_1.MAX_OXYGEN_LEVEL - game.getOxygenLevel());
        action.temperatureIncrease = Math.min(action.temperatureIncrease, (constants_1.MAX_TEMPERATURE - game.getTemperature()) / 2);
        action.venusIncrease = Math.min(action.venusIncrease, (constants_1.MAX_VENUS_SCALE - game.getVenusScaleLevel()) / 2);
        action.oceansToPlace = Math.min(action.oceansToPlace, constants_1.MAX_OCEAN_TILES - board.getOceansOnBoard());
        action.moonColonyRateIncrease = Math.min(action.moonColonyRateIncrease, constants_1.MAXIMUM_COLONY_RATE - MoonExpansion_1.MoonExpansion.getColonyRate(player));
        action.moonLogisticsRateIncrease = Math.min(action.moonLogisticsRateIncrease, constants_1.MAXIMUM_LOGISTICS_RATE - MoonExpansion_1.MoonExpansion.getLogisticRate(player));
        action.moonMiningRateIncrease = Math.min(action.moonMiningRateIncrease, constants_1.MAXIMUM_MINING_RATE - MoonExpansion_1.MoonExpansion.getMiningRate(player));
        let totalTRGain = action.TRIncrease + action.oxygenIncrease + action.temperatureIncrease + action.oceansToPlace + action.venusIncrease + action.moonColonyRateIncrease + action.moonLogisticsRateIncrease + action.moonMiningRateIncrease;
        if (player.preservationProgramActive)
            totalTRGain -= 1;
        const redTaxes = player.cardIsInEffect(CardName_1.CardName.ZAN) ? 0 : totalTRGain * constants_1.REDS_RULING_POLICY_COST;
        const hasEcologicalZone = player.cardIsInEffect(CardName_1.CardName.ECOLOGICAL_ZONE);
        const hasHerbivores = player.cardIsInEffect(CardName_1.CardName.HERBIVORES);
        const hasMartianZoo = player.cardIsInEffect(CardName_1.CardName.MARTIAN_ZOO);
        const hasMeatIndustry = player.cardIsInEffect(CardName_1.CardName.MEAT_INDUSTRY);
        const hasDecomposers = player.cardIsInEffect(CardName_1.CardName.DECOMPOSERS);
        const hasTopsoilContract = player.cardIsInEffect(CardName_1.CardName.TOPSOIL_CONTRACT);
        const hasMediaGroup = player.cardIsInEffect(CardName_1.CardName.MEDIA_GROUP);
        const hasOptimalAerobraking = player.cardIsInEffect(CardName_1.CardName.OPTIMAL_AEROBRAKING);
        const hasAdvertising = player.cardIsInEffect(CardName_1.CardName.ADVERTISING);
        const hasGMOContracts = player.cardIsInEffect(CardName_1.CardName.GMO_CONTRACT);
        const hasHomeostasisBureau = player.cardIsInEffect(CardName_1.CardName.HOMEOSTASIS_BUREAU);
        const hasStandardTechnology = player.cardIsInEffect(CardName_1.CardName.STANDARD_TECHNOLOGY);
        const hasTerraformingDeal = player.cardIsInEffect(CardName_1.CardName.TERRAFORMING_DEAL);
        const hasVenusContract = player.cardIsInEffect(CardName_1.CardName.VENUS_CONTRACT);
        const hasGordon = player.cardIsInEffect(CardName_1.CardName.GORDON);
        const hasGreta = player.cardIsInEffect(CardName_1.CardName.GRETA);
        const hasNeil = player.cardIsInEffect(CardName_1.CardName.NEIL);
        const isAphrodite = player.isCorporation(CardName_1.CardName.APHRODITE);
        const isArklight = player.isCorporation(CardName_1.CardName.ARKLIGHT);
        const isCredicor = player.isCorporation(CardName_1.CardName.CREDICOR);
        const isHelion = player.isCorporation(CardName_1.CardName.HELION);
        const isInterplanetary = player.isCorporation(CardName_1.CardName.INTERPLANETARY_CINEMATICS);
        const isManutech = player.isCorporation(CardName_1.CardName.MANUTECH);
        const isRecyclon = player.isCorporation(CardName_1.CardName.RECYCLON);
        const isVitor = player.isCorporation(CardName_1.CardName.VITOR);
        const isUNMO = player.isCorporation(CardName_1.CardName.UNITED_NATIONS_MISSION_ONE);
        const isLabourUnion = player.isCorporation(CardName_1.CardName.LABOUR_UNION);
        const isSpaceways = player.isCorporation(CardName_1.CardName.SPACEWAYS);
        const isArcadian = player.isCorporation(CardName_1.CardName.ARCADIAN_COMMUNITIES);
        let bonusMCFromPlay = action.bonusMegaCredits;
        if (isUNMO)
            bonusMCFromPlay += totalTRGain;
        if (hasTerraformingDeal)
            bonusMCFromPlay += totalTRGain * 2;
        if (hasHomeostasisBureau)
            bonusMCFromPlay += action.temperatureIncrease * 3;
        if (hasVenusContract)
            bonusMCFromPlay += action.venusIncrease * 3;
        if (hasGreta && totalTRGain > 0) {
            const greta = player.playedCards.find((c) => c.name === CardName_1.CardName.GRETA);
            if (greta.opgActionIsActive === true) {
                bonusMCFromPlay += 4;
            }
        }
        if (action.isPlantsConversion === true) {
            if (hasHerbivores && hasMeatIndustry)
                bonusMCFromPlay += 2;
            if (hasGordon)
                bonusMCFromPlay += 2;
        }
        if (action.standardProject !== undefined) {
            if (action.standardProject !== StandardProjectType_1.StandardProjectType.SELLING_PATENTS && hasStandardTechnology) {
                bonusMCFromPlay += 3;
            }
            if (action.standardProject !== StandardProjectType_1.StandardProjectType.SELLING_PATENTS && isLabourUnion) {
                bonusMCFromPlay += 4;
            }
            if (action.standardProject === StandardProjectType_1.StandardProjectType.GREENERY) {
                if (isCredicor)
                    bonusMCFromPlay += 4;
                if (hasHerbivores && hasMeatIndustry)
                    bonusMCFromPlay += 2;
                if (hasGordon)
                    bonusMCFromPlay += 2;
            }
        }
        if (action.card !== undefined) {
            if (hasGMOContracts) {
                bonusMCFromPlay += action.card.tags.filter((tag) => tag === Tags_1.Tags.ANIMAL || tag === Tags_1.Tags.PLANT || tag === Tags_1.Tags.MICROBE).length * 2;
            }
            if (hasTopsoilContract) {
                if (action.card.resourceType === ResourceType_1.ResourceType.MICROBE || player.getResourceCards(ResourceType_1.ResourceType.MICROBE).length > 0) {
                    bonusMCFromPlay += action.microbes;
                }
                if (hasDecomposers) {
                    bonusMCFromPlay += action.card.tags.filter((tag) => tag === Tags_1.Tags.ANIMAL || tag === Tags_1.Tags.PLANT || tag === Tags_1.Tags.MICROBE).length;
                }
                if (isRecyclon) {
                    bonusMCFromPlay += action.card.tags.filter((tag) => tag === Tags_1.Tags.BUILDING).length;
                }
            }
            if (hasMeatIndustry) {
                if (action.card.resourceType === ResourceType_1.ResourceType.ANIMAL || player.getResourceCards(ResourceType_1.ResourceType.ANIMAL).length > 0) {
                    bonusMCFromPlay += action.animals;
                }
                if (hasEcologicalZone) {
                    bonusMCFromPlay += action.card.tags.filter((tag) => tag === Tags_1.Tags.ANIMAL || tag === Tags_1.Tags.PLANT).length * 2;
                }
                if (hasMartianZoo) {
                    bonusMCFromPlay += action.card.tags.filter((tag) => tag === Tags_1.Tags.EARTH).length * 2;
                }
                if (isArklight) {
                    bonusMCFromPlay += action.card.tags.filter((tag) => tag === Tags_1.Tags.ANIMAL || tag === Tags_1.Tags.PLANT).length * 2;
                }
                if (hasHerbivores && action.nonOceanToPlace === TileType_1.TileType.GREENERY) {
                    bonusMCFromPlay += 2;
                }
            }
            if (hasGordon && action.nonOceanToPlace === TileType_1.TileType.GREENERY) {
                bonusMCFromPlay += 2;
            }
            if (action.card.cost >= 20) {
                if (isCredicor)
                    bonusMCFromPlay += 4;
                if (hasAdvertising && isManutech)
                    bonusMCFromPlay += 1;
            }
            if (action.card.cardType === CardType_1.CardType.EVENT) {
                if (isInterplanetary)
                    bonusMCFromPlay += 2;
                if (isSpaceways && action.card.tags.includes(Tags_1.Tags.SPACE))
                    bonusMCFromPlay += 2;
                if (hasMediaGroup)
                    bonusMCFromPlay += 3;
                if (hasOptimalAerobraking && action.card.tags.some((tag) => tag === Tags_1.Tags.SPACE)) {
                    bonusMCFromPlay += 3;
                    if (isHelion)
                        bonusMCFromPlay += 3;
                }
            }
            if (hasNeil && action.card.tags.some((tag) => tag === Tags_1.Tags.MOON)) {
                const moonTagsCount = action.card.tags.filter((tag) => tag === Tags_1.Tags.MOON).length;
                bonusMCFromPlay += moonTagsCount;
            }
            if (isVitor && action.card.getVictoryPoints !== undefined && action.card.getVictoryPoints(player) >= 0) {
                bonusMCFromPlay += 3;
            }
            action.cost = player.getCardCost(action.card);
        }
        if (isAphrodite)
            bonusMCFromPlay += action.venusIncrease * 2;
        if (isHelion)
            bonusMCFromPlay -= action.reservedHeat;
        if (isManutech)
            bonusMCFromPlay += action.megaCreditsProduction;
        const totalToPay = redTaxes + action.cost - bonusMCFromPlay;
        if (player.canAfford(totalToPay))
            return { canAfford: true, oceansToPlace: action.oceansToPlace, bonusMCFromPlay: bonusMCFromPlay, redTaxes: redTaxes };
        const spendableMegacredits = player.spendableMegacredits();
        let mustSpendAtMost = spendableMegacredits - (redTaxes - bonusMCFromPlay);
        let missingMC = totalToPay - player.spendableMegacredits();
        if (canUsePlants) {
            const plantsUsed = Math.min(player.plants, Math.ceil(missingMC / constants_1.DEFAULT_PLANT_VALUE));
            missingMC -= plantsUsed * constants_1.DEFAULT_PLANT_VALUE;
        }
        if (canUseSteel) {
            const steelValue = player.getSteelValue();
            const steelUsed = Math.min(player.steel, Math.ceil(missingMC / steelValue));
            missingMC -= steelUsed * steelValue;
        }
        if (canUseTitanium) {
            const titaniumValue = player.getTitaniumValue();
            const titaniumUsed = Math.min(player.titanium, Math.ceil(missingMC / titaniumValue));
            missingMC -= titaniumUsed * titaniumValue;
            if (titaniumUsed > 0 && Math.abs(missingMC) % titaniumValue === titaniumValue - 1 && mustSpendAtMost + 1 < spendableMegacredits) {
                mustSpendAtMost += 1;
            }
        }
        if (canUseMicrobes) {
            missingMC -= Math.min(player.getMicrobesCanSpend(), Math.ceil(missingMC / constants_1.DEFAULT_MICROBES_VALUE)) * constants_1.DEFAULT_MICROBES_VALUE;
        }
        if (canUseFloaters) {
            missingMC -= Math.min(player.getFloatersCanSpend(), Math.ceil(missingMC / constants_1.DEFAULT_FLOATERS_VALUE)) * constants_1.DEFAULT_FLOATERS_VALUE;
        }
        if (canUseScience) {
            missingMC -= Math.min(player.getSpendableScienceResources(), missingMC);
        }
        if (canUseAsteroids) {
            missingMC -= Math.min(player.getSpendableAsteroidResources(), missingMC);
        }
        if (canUseSpireScience) {
            missingMC -= Math.min(player.getSpendableSpireScienceResources(), Math.ceil(missingMC / constants_1.DEFAULT_SPIRE_SCIENCE_VALUE)) * constants_1.DEFAULT_SPIRE_SCIENCE_VALUE;
        }
        if (canUseGraphene) {
            missingMC -= Math.min(player.getSpendableGrapheneResources(), Math.ceil(missingMC / constants_1.DEFAULT_GRAPHENE_VALUE)) * constants_1.DEFAULT_GRAPHENE_VALUE;
        }
        if (missingMC <= 0 && mustSpendAtMost >= 0) {
            if ((action.nonOceanToPlace === undefined && action.oceansToPlace === 0) || (action.nonOceanToPlace !== undefined && action.nonOceanToPlace !== TileType_1.TileType.OCEAN)) {
                return { canAfford: true, mustSpendAtMost: mustSpendAtMost, oceansToPlace: action.oceansToPlace, bonusMCFromPlay: bonusMCFromPlay, redTaxes: redTaxes };
            }
            else {
                mustSpendAtMost += missingMC;
            }
        }
        if (action.oceansToPlace === 0 && action.nonOceanToPlace === undefined) {
            return { canAfford: false, oceansToPlace: action.oceansToPlace, redTaxes: redTaxes };
        }
        const oceansToPlace = ((_a = action.card) === null || _a === void 0 ? void 0 : _a.name) === CardName_1.CardName.ARTIFICIAL_LAKE ? 0 : action.oceansToPlace;
        const spacesBonusMC = RedsPolicy.getBoardSpacesBonusMC(player, game, action.nonOceanAvailableSpaces, oceansToPlace, isHelion, isArcadian);
        const [spacesTree, max] = RedsPolicy.makeISpaceTree(player, game, spacesBonusMC, oceansToPlace, action.oceansAvailableSpaces, action.nonOceanToPlace !== undefined ? 1 : 0, action.nonOceanAvailableSpaces, missingMC, mustSpendAtMost);
        const tilePlacementWarningMessage = 'Tile placement will be limited due to Reds policy.';
        if (spacesTree.size > 0) {
            if (action.card !== undefined) {
                if (action.card.warning !== undefined && action.card.warning.includes(tilePlacementWarningMessage) === false) {
                    action.card.warning += ` ${tilePlacementWarningMessage}`;
                }
                else {
                    action.card.warning = tilePlacementWarningMessage;
                }
            }
            const adjustment = oceansToPlace > 0 ? max : Math.max(...spacesBonusMC);
            const adjustedMustSpendAtMost = Math.min(player.megaCredits, mustSpendAtMost + adjustment);
            if (adjustedMustSpendAtMost >= 0) {
                return {
                    canAfford: true,
                    mustSpendAtMost: adjustedMustSpendAtMost,
                    spaces: spacesTree,
                    oceansToPlace: action.oceansToPlace,
                    bonusMCFromPlay: bonusMCFromPlay + Math.max(...spacesBonusMC),
                    redTaxes: redTaxes
                };
            }
        }
        return { canAfford: false, oceansToPlace: action.oceansToPlace, redTaxes: redTaxes };
    }
    static getBoardSpacesBonusMC(player, game, nonOceanAvailableSpaces, oceansToPlace, isHelion, isArcadian) {
        const board = game.board;
        return board.spaces.map((space) => {
            const adjacentSpaces = board.getAdjacentSpaces(space);
            let bonus = adjacentSpaces.filter((s) => Board_1.Board.isOceanSpace(s)).length * player.oceanBonus;
            if (space.player === player && isArcadian)
                bonus += 3;
            if (oceansToPlace > 0 && nonOceanAvailableSpaces.length > 0) {
                const adjacentEmptyOceanSpacesCount = adjacentSpaces.filter((s) => s.tile === undefined && s.spaceType === SpaceType_1.SpaceType.OCEAN).length;
                const oceanAdjacencyBonus = Math.min(adjacentEmptyOceanSpacesCount, oceansToPlace) * player.oceanBonus;
                if (adjacentSpaces.some((space) => nonOceanAvailableSpaces.includes(space))) {
                    bonus += oceanAdjacencyBonus;
                }
            }
            if (game.gameOptions.aresExtension) {
                const hasBonusFromCapitalAres = adjacentSpaces.some((space) => space.tile !== undefined && space.tile.tileType === TileType_1.TileType.CAPITAL);
                const hasBonusFromCommercialDistrictAres = adjacentSpaces.some((space) => space.tile !== undefined && space.tile.tileType === TileType_1.TileType.COMMERCIAL_DISTRICT);
                const hasBonusFromNaturalPreserveAres = adjacentSpaces.some((space) => space.tile !== undefined && space.tile.tileType === TileType_1.TileType.NATURAL_PRESERVE);
                const hasPenaltyFromNuclearZoneAres = adjacentSpaces.some((space) => space.tile !== undefined && space.tile.tileType === TileType_1.TileType.NUCLEAR_ZONE);
                if (hasBonusFromCapitalAres)
                    bonus += 2;
                if (hasBonusFromCommercialDistrictAres)
                    bonus += 2;
                if (hasBonusFromNaturalPreserveAres)
                    bonus += 1;
                if (hasPenaltyFromNuclearZoneAres)
                    bonus -= 2;
                if (isHelion) {
                    const hasBonusFromLavaFlowsAres = adjacentSpaces.some((space) => space.tile !== undefined && space.tile.tileType === TileType_1.TileType.LAVA_FLOWS);
                    const hasBonusFromMoholeAreaAres = adjacentSpaces.some((space) => space.tile !== undefined && space.tile.tileType === TileType_1.TileType.MOHOLE_AREA);
                    if (hasBonusFromLavaFlowsAres)
                        bonus += 2;
                    if (hasBonusFromMoholeAreaAres)
                        bonus += 2;
                }
                const hasMeatIndustry = player.cardIsInEffect(CardName_1.CardName.MEAT_INDUSTRY);
                const hasTopsoilContract = player.cardIsInEffect(CardName_1.CardName.TOPSOIL_CONTRACT);
                if (hasMeatIndustry) {
                    const hasBonusFromEcologicalZoneAres = adjacentSpaces.some((space) => space.tile !== undefined && space.tile.tileType === TileType_1.TileType.ECOLOGICAL_ZONE);
                    const hasBonusFromOceanSanctuary = adjacentSpaces.some((space) => space.tile !== undefined && space.tile.tileType === TileType_1.TileType.OCEAN_SANCTUARY);
                    if (hasBonusFromEcologicalZoneAres)
                        bonus += 2;
                    if (hasBonusFromOceanSanctuary)
                        bonus += 2;
                }
                if (hasTopsoilContract) {
                    const hasBonusFromBiofertilizerFacility = adjacentSpaces.some((space) => space.tile !== undefined && space.tile.tileType === TileType_1.TileType.BIOFERTILIZER_FACILITY);
                    if (hasBonusFromBiofertilizerFacility)
                        bonus += 1;
                }
            }
            const hasZan = player.cardIsInEffect(CardName_1.CardName.ZAN);
            if (AresHandler_1.AresHandler.hazardSeverity(space) === AresHandler_1.HazardSeverity.MILD) {
                bonus -= 8;
                if (!hasZan)
                    bonus -= constants_1.REDS_RULING_POLICY_COST;
            }
            else if (AresHandler_1.AresHandler.hazardSeverity(space) === AresHandler_1.HazardSeverity.SEVERE) {
                bonus -= 16;
                if (!hasZan)
                    bonus -= 2 * constants_1.REDS_RULING_POLICY_COST;
            }
            if (space.bonus.includes(SpaceBonus_1.SpaceBonus.OCEAN))
                bonus -= constants_1.HELLAS_BONUS_OCEAN_COST;
            if (space.bonus.includes(SpaceBonus_1.SpaceBonus.TEMPERATURE))
                bonus -= constants_1.VASTITAS_BOREALIS_BONUS_TEMPERATURE_COST;
            if (isHelion)
                bonus += space.bonus.filter(b => b === SpaceBonus_1.SpaceBonus.HEAT).length;
            return bonus;
        });
    }
    static makeISpaceTree(player, game, spacesBonusMC, oceans, oceansSpaces, nonOcean, nonOceanSpaces, target, mustSpendAtMost, iteration = 1, totalBonus = 0, max = 0) {
        const spacesTree = new Map();
        const board = game.board;
        if (iteration < oceans + nonOcean) {
            oceansSpaces.forEach((space) => {
                const tempBonusMC = Array.from(spacesBonusMC);
                const adjacentSpaces = board.getAdjacentSpaces(space);
                adjacentSpaces.forEach((s) => {
                    if (nonOceanSpaces.length === 0) {
                        if (adjacentSpaces.some((adjSpace) => {
                            const hasEnoughPlacementBonus = spacesBonusMC[board.spaces.indexOf(adjSpace)] >= totalBonus;
                            const isOceanSpace = adjSpace.spaceType === SpaceType_1.SpaceType.OCEAN;
                            return hasEnoughPlacementBonus && (adjSpace.tile !== undefined || oceans > 1) && isOceanSpace;
                        })) {
                            tempBonusMC[board.spaces.indexOf(s)] += player.oceanBonus;
                        }
                        else {
                            tempBonusMC[board.spaces.indexOf(s)] = 0;
                        }
                    }
                    else {
                        if (adjacentSpaces.some((adjSpace) => {
                            const hasEnoughPlacementBonus = spacesBonusMC[board.spaces.indexOf(adjSpace)] >= totalBonus;
                            return hasEnoughPlacementBonus && nonOceanSpaces.includes(adjSpace);
                        })) {
                            tempBonusMC[board.spaces.indexOf(s)] += player.oceanBonus;
                        }
                        else {
                            tempBonusMC[board.spaces.indexOf(s)] = 0;
                        }
                    }
                });
                const [tree, branchMax] = RedsPolicy.makeISpaceTree(player, game, tempBonusMC, oceans, oceansSpaces.filter((s) => s.id !== space.id).filter((s) => tempBonusMC[board.spaces.indexOf(s)] >= target), nonOcean, nonOceanSpaces.filter((s) => s.id !== space.id), target, mustSpendAtMost, iteration + 1, totalBonus + tempBonusMC[board.spaces.indexOf(space)], Math.max(...tempBonusMC));
                if (branchMax > max)
                    max = branchMax;
                if (tree.size > 0)
                    spacesTree.set(space, tree);
            });
        }
        else {
            let spaces = nonOcean === 0 ? oceansSpaces : nonOceanSpaces;
            if (Math.max(...spacesBonusMC) >= target && nonOcean === 0)
                spaces = board.getAvailableSpacesForOcean(player);
            target = Math.abs(target);
            mustSpendAtMost += Math.max(...spacesBonusMC);
            spaces.forEach((space) => {
                const bonus = totalBonus + spacesBonusMC[board.spaces.indexOf(space)];
                if (bonus >= target)
                    spacesTree.set(space, undefined);
            });
        }
        return [spacesTree, Math.max(...spacesBonusMC, max)];
    }
}
exports.RedsPolicy = RedsPolicy;
//# sourceMappingURL=RedsPolicy.js.map